module.exports = __webpack_public_path__ + "img/图片14.9d0653c4.png";